import { render } from "./PROPOSAL_VOTING_PROVIDED.vue?vue&type=template&id=d3c9fc72"
import script from "./PROPOSAL_VOTING_PROVIDED.vue?vue&type=script&lang=js"
export * from "./PROPOSAL_VOTING_PROVIDED.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__